export const environment = {
  production: false,
  apiUrl: 'https://api-dev.signingroom.io' 
};